import atMessages from './at.json'
import daMessages from './da.json'
import deMessages from './de.json'
import enMessages from './en.json'
import esMessages from './es.json'
import frMessages from './fr.json'
import hrMessages from './hr.json'
import itMessages from './it.json'
import nbMessages from './nb.json'
import nlMessages from './nl.json'
import plMessages from './pl.json'
import svMessages from './sv.json'

export const localeTranslations = {
  en: enMessages,
  da: daMessages,
  de: deMessages,
  nl: nlMessages,
  nb: nbMessages,
  sv: svMessages,
  es: esMessages,
  fr: frMessages,
  it: itMessages,
  pl: plMessages,
  at: atMessages,
  hr: hrMessages,
}
